import { render } from "./ClosetClothingDetailView.vue?vue&type=template&id=d07cfa64&ts=true"
import script from "./ClosetClothingDetailView.vue?vue&type=script&lang=ts"
export * from "./ClosetClothingDetailView.vue?vue&type=script&lang=ts"

import "./ClosetClothingDetailView.vue?vue&type=style&index=0&id=d07cfa64&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__